import { useEffect, useRef } from "react"
import { H1 } from "@holigral/shared/ui/components"
import { Card, CardContent } from "@holigral/shared/ui/components/ui/card"
import { useSubmitContactMutation } from "./api"
import {
  ApiFormWrapper,
  FormError,
  FormInput,
  FormSubmitButton,
  FormTextarea,
} from "@/form"
import { Trans, useT } from "@/i18n"

const SUPPORT_EMAIL = "hello@profiling.app"

export default function Contact() {
  const { t } = useT("content")
  const pageLoadRef = useRef(0)
  const [submitContact] = useSubmitContactMutation()

  useEffect(() => {
    pageLoadRef.current = Math.floor(Date.now() / 1000)
  }, [])

  return (
    <div className="mx-auto max-w-lg px-6 py-12">
      <H1>{t("getInTouch")}</H1>

      <p className="mb-4 text-muted-foreground">
        <Trans
          t={t}
          i18nKey="contactIntro"
          values={{ email: SUPPORT_EMAIL }}
          components={{
            supportLink: (
              <a
                href={`mailto:${SUPPORT_EMAIL}`}
                className="text-foreground hover:underline"
              />
            ),
          }}
        />
      </p>

      <Card>
        <CardContent>
          <ApiFormWrapper
            defaultValues={{
              name: "",
              email: "",
              company: null,
              message: "",
              website: null,
            }}
            action={(values) =>
              submitContact({
                ...values,
                t: pageLoadRef.current,
              })
            }
            successMessage="Message sent! We'll get back to you soon."
            resetOnSuccess
          >
            <div className="space-y-4">
              <FormInput
                name="name"
                placeholder="Your name"
                required
                autoFocus
              />
              <FormInput
                name="email"
                type="email"
                autoComplete="email"
                placeholder="Your email"
                required
              />
              <FormInput name="company" placeholder="Your company" />
              <FormTextarea
                name="message"
                placeholder="How can we help you?"
                required
                rows={5}
              />

              {/* Honeypot – hidden from real users */}
              <div className="sr-only" aria-hidden="true">
                <FormInput name="website" tabIndex={-1} autoComplete="off" />
              </div>

              <FormError />
              <FormSubmitButton disabledUntilDirty={false}>
                {t("sendMessage")}
              </FormSubmitButton>
            </div>
          </ApiFormWrapper>
        </CardContent>
      </Card>
    </div>
  )
}
